import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Introduction from '../introduction';

export type IAnimationSrc =
    | object
    | {
          default: object;
      };

const AnimationFlow = ({ onSkip, desktopSrc, mobileSrc }: { onSkip: () => void; desktopSrc: IAnimationSrc; mobileSrc?: IAnimationSrc }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <>
            <Introduction onSkip={onSkip} src={isMobile ? mobileSrc || desktopSrc : desktopSrc} loop={false} />
        </>
    );
};

export default AnimationFlow;
